import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { Search, UserProfileImage } from '@domain-group/suit-theme'

import searchFn from '@functions/search'

import type { UserModel } from '@models/types'

import type { EntityOptions } from '@redux/modules/types'

type MapUserResultsParams = {
  secondaryTextProperty?: string,
  selectedIds?: number[],
  users: UserModel[],
}

const mapUserResults = (params: MapUserResultsParams) => {
  const {
    secondaryTextProperty = '', selectedIds = [], users,
  } = params

  const filteredUsers = users.filter(user => !selectedIds.includes(user.id))

  const results = {
    groups: [
      {
        key: 'user',
        title: 'USERS',
        items: filteredUsers
          .map((user) => {
            const imageUrl = digObject(user, 'image.thumb_url', '')
            const secondaryText = digObject(user, secondaryTextProperty, '')

            return {
              ...user,
              iconLeft: (
                <UserProfileImage imageUrl={imageUrl}>
                  <FontAwesomeIcon icon={faUser} />
                </UserProfileImage>
              ),
              key: `User-${user.id}`,
              secondaryText: secondaryTextProperty === 'id' ? `#${secondaryText}` : secondaryText,
              text: user.full_name,
            }
          }),
      },
    ],
  }

  return results
}

interface UserSearchProps {
  callbacks: {
    onChange?: (value: string) => void,
    selectItem: (item: UserModel) => void,
  },
  endpoint?: string,
  requestOptions?: EntityOptions,
  secondaryTextProperty?: string,
  selectedIds?: number[],
  value?: string,
}

const UserSearch = (props: UserSearchProps) => {
  const {
    callbacks: {
      onChange,
      selectItem,
    },
    endpoint = 'users.json',
    requestOptions,
    secondaryTextProperty,
    selectedIds,
    value,
  } = props

  return (
    <Search
      callbacks={{
        onChange,
        search: searchFn,
        selectItem,
        mapResults: users => mapUserResults({
          secondaryTextProperty, selectedIds, users,
        }),
      }}
      debounceInterval={300}
      endpoint={endpoint}
      forwardProps={{
        closeOnSelect: true,
        setStringOnSelect: false,
        showOnFocus: true,
      }}
      requestOptions={{
        ...requestOptions,
        include_image_sizes: true,
        include_user_image: true,
      }}
      value={value}
    />
  )
}

export default UserSearch
